<template>
  <span class="title" v-if="getProductPreventAutoCorrection === true">
    désactivé
  </span>
  <span class="title" v-else-if="getValue > 0">
    enlève {{ Math.abs(getValue) }}% à la consommation
  </span>
  <span class="title" v-else-if="getValue < 0">
    rajoute {{ Math.abs(getValue) }}% à la consommation
  </span>
  <span class="title" v-else>
    ne fait rien
  </span>
</template>

<script>
import { api } from "@/api";
import { round10 } from "round10";
import { mapGetters } from "vuex";
export default {
  name: "CorrectionValue",
  props: {
    product: {
      required: true
    }
  },
  mounted() {
    if (this.product !== undefined && this.product !== null) {
      this.getData();
    }
  },
  computed: {
    ...mapGetters(["getProducts"]),
    getProductPreventAutoCorrection() {
      const p = this.getProducts.find(x => x.id === this.product);
      if (p) {
        return p.prevent_inventory_auto_correction;
      } else {
        return false;
      }
    },
    getValue() {
      if (
        this.data !== undefined &&
        this.data.value !== undefined &&
        this.data.value !== null
      ) {
        return round10(this.data.value * 100, -2);
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      data: undefined,
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        const res = await api.getInventoryCorrectionValues({
          product: this.product
        });
        if (res.length > 0) {
          this.data = res[0];
        } else {
          this.data = undefined;
        }
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    product(v) {
      if (v !== undefined && v !== null) {
        this.getData();
      } else {
        this.data = undefined;
      }
    }
  }
};
</script>

<style></style>
